import React from "react";
import Work from "./Work";

const Experience=()=>
{
    return(
        <>
        <Work/>
        </>
    )
}

export default Experience;